export default __webpack_public_path__ + "static/symmetry-3395a1aab20ea5ef4fa0c0809b47c8a9.png";